<template>
  <div class="tech-background">
    <!-- 网格背景 -->
    <div class="grid-bg"></div>
    <!-- 粒子效果 -->
    <canvas ref="particleCanvas" class="particle-canvas"></canvas>
    <!-- 几何装饰 -->
    <div class="geometry-decoration"></div>
  </div>
</template>

<script>
export default {
  name: 'TechBackground',
  data() {
    return {
      particles: [],
      animationId: null,
    }
  },
  mounted() {
    this.initParticles()
    this.animateParticles()
  },
  beforeDestroy() {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId)
    }
  },
  methods: {
    initParticles() {
      const canvas = this.$refs.particleCanvas
      canvas.width = window.innerWidth
      canvas.height = window.innerHeight
      
      const particleCount = Math.floor((canvas.width * canvas.height) / 15000)
      this.particles = Array.from({ length: particleCount }, () => ({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        size: Math.random() * 2 + 0.5,
        speedX: (Math.random() - 0.5) * 0.5,
        speedY: (Math.random() - 0.5) * 0.5,
        opacity: Math.random() * 0.5 + 0.2,
      }))
    },
    animateParticles() {
      const canvas = this.$refs.particleCanvas
      const ctx = canvas.getContext('2d')
      
      const animate = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        
        this.particles.forEach(particle => {
          particle.x += particle.speedX
          particle.y += particle.speedY
          
          if (particle.x < 0) particle.x = canvas.width
          if (particle.x > canvas.width) particle.x = 0
          if (particle.y < 0) particle.y = canvas.height
          if (particle.y > canvas.height) particle.y = 0
          
          ctx.beginPath()
          ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2)
          ctx.fillStyle = `rgba(99, 179, 237, ${particle.opacity})`
          ctx.fill()
        })
        
        this.particles.forEach((p1, i) => {
          this.particles.slice(i + 1).forEach(p2 => {
            const dx = p1.x - p2.x
            const dy = p1.y - p2.y
            const distance = Math.sqrt(dx * dx + dy * dy)
            
            if (distance < 150) {
              ctx.beginPath()
              ctx.moveTo(p1.x, p1.y)
              ctx.lineTo(p2.x, p2.y)
              ctx.strokeStyle = `rgba(49, 130, 206, ${0.1 * (1 - distance / 150)})`
              ctx.stroke()
            }
          })
        })
        
        this.animationId = requestAnimationFrame(animate)
      }
      
      animate()
    },
  },
}
</script>

<style scoped>
.tech-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #0a1628 0%, #0d1f3c 50%, #0a1628 100%);
  overflow: hidden;
  z-index: 0;
}

.grid-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(rgba(49, 130, 206, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(49, 130, 206, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  opacity: 0.6;
}

.particle-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.geometry-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: 
    radial-gradient(ellipse at 20% 20%, rgba(99, 179, 237, 0.05) 0%, transparent 50%),
    radial-gradient(ellipse at 80% 80%, rgba(99, 179, 237, 0.05) 0%, transparent 50%),
    radial-gradient(ellipse at 50% 50%, rgba(49, 130, 206, 0.03) 0%, transparent 70%);
}
</style>
